import React, { useState, useEffect } from "react";
import { Badge, Col, Row } from "react-bootstrap";

import AllActivities from "../../../Components/AllActivities";
import getAllActivities from "../../../Services/AllActivities";
import ListPagination from "../../../Components/Pagination";
import { activityListPerPage } from "../../../Utilities/Helper";
import GroupListing from "../../../Components/GroupListing";
import { getGroupsWithJSCount } from "../../../Services/AdminManageUsersServices";

export default function GroupListingForJS() {
  const [users, setUsers] = useState([]);
  const [totalUser, setTotalUser] = useState();
  const [totalJSCount, setTotalJSCount] = useState();
  const [currentPage, setCurrentPage] = useState("");
  const [showSpinnerForActivities, setShowSpineerForActivities] =
    useState(true);

  useEffect(() => {
    async function allUsers() {
      const filter = "recordperpage=" + activityListPerPage + currentPage;
      await getGroupsWithJSCount(filter)
        .then((res) => {
          const result = res;
          setUsers(result.groupModels);
          setTotalUser(result.totalGroupCount);
          setTotalJSCount(result.jobSeekerTotalCount);
          setShowSpineerForActivities(false);
        })
        .catch((err) => {
          console.log("JobSeeker: ", err);
          setShowSpineerForActivities(false);
        });
    }
    allUsers();
  }, [currentPage]);

  const pageChangeHandler = (page) => {
    setCurrentPage(`&page=${page}`);
    setShowSpineerForActivities(true);
  };

  return (
    <div className="container p-0">
      <h1 className="page-title">
        Job Seekers{" "}
        <Badge
          pill
          bg="danger"
          className="bg-warning text-white px-3 ml-3 font-weight-normal"
        >
          {totalJSCount}
        </Badge>
      </h1>
      <div className="dashboard-wrapper resumes-page">
        <Row>
          <Col md={12}>
            <div className="dashboard-box activities dashboard-col-bg mb-4 admin-members"> 
              <GroupListing
                groups={users}
                showSpinner={showSpinnerForActivities}
              />
              {users.length !== 0 && (
                <ListPagination
                  recordPerPage={activityListPerPage}
                  TotalRecord={totalUser}
                  className="mt-3"
                  onPageChange={pageChangeHandler}
                />
              )}
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
}
// export default ActivitiesList;
